import { Box, HintIcon, RequiredTag, Space, Text } from '@/components';
import type { CSSProperties, FC, ReactNode } from 'react';
import { z } from 'zod';
import type { TextVariant } from '../Text/Text';

type Props = {
  text: string;
  required?: boolean;
  hint?: string;
  size?: FieldLabelSize;
  style?: CSSProperties;
  additionalComponent?: ReactNode;
};

// NOTES: 2025/03/19 時点では 'large' は KS と SS でしか使われていない
const fieldLabelSizeType = z.enum(['small', 'medium', 'large']);

export type FieldLabelSize = z.infer<typeof fieldLabelSizeType>;

const FieldLabelVariantType = {
  small: 'footnote',
  medium: 'body',
  large: 'h5',
} as const satisfies Record<FieldLabelSize, TextVariant>;

export const FieldLabel: FC<Props> = ({
  text,
  required,
  hint,
  size = 'medium',
  style,
  additionalComponent,
}) => {
  return (
    <div data-dd-privacy="allow">
      <Space size={4} align="center">
        <Box display="flex" alignItems="center">
          <Text
            text={text}
            variant={FieldLabelVariantType[size]}
            style={style}
            color={size !== 'large' ? 'secondary' : undefined}
            weight={size !== 'large' ? 'regular' : undefined}
          />
        </Box>
        {required && (
          <Box display="flex" alignItems="center">
            <RequiredTag />
          </Box>
        )}
        {hint && <HintIcon hint={hint} />}
        {additionalComponent}
      </Space>
    </div>
  );
};
